import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Checkbox, FormControl, InputLabel, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';
import { cloneDeep, debounce } from 'lodash';
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { ParentScreenCtx } from '../../../pages/workbench_build/WorkbenchBuild';
import { useTranslation } from 'react-i18next';
import { fieldTypeOptionsArray } from '../../../constants/constantList';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { SectionHeader } from './SectionHeader';
import SourceType from '../../TemplateProperties/SourceType';
import FormattingOptions from './FormattingOptions';
import { eachDeep } from 'deepdash-es/standalone';
import { treeActions } from '../../../redux/slices/treeSlice';
import { ConstantValueControl } from './OutboundFieldFormattingOptions/ConstantValueControl';
import LabeledCheckbox from '../../TemplateProperties/TPCheckbox';
import { api } from '../../../redux/api';
import CommonGrid from '../../Repository/CommonGrid';

const TrackingReportProperties = () => {
    const { t } = useTranslation();
    const { account, user } = useSelector((state) => state.queryParams);
    const parentScreen = useContext(ParentScreenCtx);
    const [rowData] = useState([]);
    const [gridAPI, setGridAPI] = useState();
    const fieldOptionsDropdownArray = cloneDeep(fieldTypeOptionsArray);
    fieldOptionsDropdownArray.splice(3, null, { value: "CONSTANT", text: "CONSTANT" })
    const [reportNameDropdown, setReportNameDropdown] = useState([]);
    const currentSelectedField = useRef({});
    const [currentSelectedFieldState, setCurrentSelectedFieldState] = useState({});
    const statementTypeDropdown = ["Insert", "Update"];
    const [fieldOptions, setFieldOptions] = useState([]);
    const [fieldType, setFieldType] = useState("SELECT");
    const [trackingReport, setTrackingReport] = useState("");
    const [statementType, setStatementType] = useState("");
    const [performCheckbox, setPerformCheckbox] = useState(true);
    const [ignoreCheckbox, setIgnoreCheckbox] = useState(false);
    const [reportName, setReportName] = useState("");
    const [constantValue, setConstantValue] = useState("");
    const [repeatTimes, setRepeatTimes] = useState("");
    const [ignoreGlobalSubstitution, setIgnoreGlobalSubstitution] = useState(false);
    const constantValueDropDownMenu = ["", t("CRLF"), t("RECORD_DELIMITER")];
    const { leftTree, rightTree } = useSelector((state) => state.treeData[parentScreen]);
    const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
    const selectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
    const [bitPosition, setBitPosition] = useState("1");
    const [bitValue, setBitValue] = useState("0");
    const [isIbPatternDisabled, setIsIbPatternDisabled] = useState(false);
    const trackingReportUpdated = useSelector((state) => state.treeData.trackingReportUpdated);  
    const dispatch = useDispatch();

    const bitValueDropdown = useMemo(() =>
        ["0", "1"].map(
            (e, i) => (
                <MenuItem key={`bitValue-${i}`} value={e}>
                    {e}
                </MenuItem>
            )),
        []
    );

    const bitPositionDropdown = useMemo(
        () =>
            ["1", "2", "3", "4", "5", "6", "7", "8"].map((e, i) => (
                <MenuItem key={`bitPosition-${i}`} value={e}>
                    {e}
                </MenuItem>
            )),
        []
    );

    const submitTrfChange = (key, val, valuesObj, deleteField) => {
        const updatedData = eachDeep(cloneDeep(translatedData), (objValue) => {
            if (objValue?.key !== selectedNode.key) {
                return;
            }

            let fieldData = { ...objValue['TRACKING_REPORT_DETAILS'][currentSelectedField?.current?.id || 0]['TRACKING_REPORT_FIELD']};

            if(key === "FIELDTYPE") {
                let BitFields = {
                    BIT_POSITION:"1",
                    LENGTH:"0",
                    PRECISION:"0",
                    PRECISION_OUT:"0",
                    ROUND:"TRUE"
                }

                if (val === "BIT_FLAG") {
                    currentSelectedField.current = {
                        ...currentSelectedField.current,
                        ...BitFields
                    }

                    setCurrentSelectedFieldState(currentSelectedField.current);

                    gridAPI && gridAPI.forEachNode((node) => {
                        if (node.data?.id === currentSelectedField?.current?.id) {
                            node.data = { ...node.data, ...BitFields };
                        }
                    })

                    objValue['TRACKING_REPORT_DETAILS'][currentSelectedField?.current?.id || 0]['TRACKING_REPORT_FIELD'] =
                        { ...fieldData, ...BitFields };

                } else if (val !== "BIT_FLAG") {
                    let removeFields = ["PRECISION", "PRECISION_OUT", "ROUND", "VALUE"];
                    removeFields.forEach(item => {
                        fieldData.hasOwnProperty(item) && delete fieldData[item];
                        currentSelectedField.current.hasOwnProperty(item) && delete currentSelectedField.current[item];
                        setCurrentSelectedFieldState(currentSelectedField.current);
                    })

                    objValue['TRACKING_REPORT_DETAILS'][currentSelectedField?.current?.id || 0]['TRACKING_REPORT_FIELD'] = { ...fieldData };

                    gridAPI && gridAPI.forEachNode((node) => {
                        if (node.data?.id === currentSelectedField?.current?.id) {
                            removeFields.forEach(item => {
                                node?.data.hasOwnProperty(item) && delete node.data[item];
                            })
                        }
                    })
                }

                currentSelectedField.current.FIELDTYPE = val;
                setCurrentSelectedFieldState(currentSelectedField.current);
                gridAPI && gridAPI.forEachNode((node) => {
                    if (node.data?.id === currentSelectedField?.current?.id) {
                        node.data.FIELDTYPE = val;
                    }
                })
                
                objValue['TRACKING_REPORT_DETAILS'][currentSelectedField?.current?.id || 0]['TRACKING_REPORT_FIELD'].FIELDTYPE = val;
            } else if (key && val) {
                if (key === "RPT_TRUNC_ERR") {
                    if (val === "TRUE") {
                        currentSelectedField?.current?.hasOwnProperty(key) && delete currentSelectedField.current[key];
                        gridAPI && gridAPI.forEachNode((node) => {
                            if (node.data?.id === currentSelectedField?.current?.id) {
                                node?.data?.hasOwnProperty(key) && delete node.data[key];
                            }
                        })
                        objValue['TRACKING_REPORT_DETAILS'][currentSelectedField?.current?.id || 0]['TRACKING_REPORT_FIELD'].hasOwnProperty(key)
                            && delete objValue['TRACKING_REPORT_DETAILS'][currentSelectedField?.current?.id || 0]['TRACKING_REPORT_FIELD'][key];
                    } else {
                        currentSelectedField.current[key] = val;
                        gridAPI && gridAPI.forEachNode((node) => {
                            if (node.data?.id === currentSelectedField?.current?.id) {
                                node.data[key] = val;
                            }
                        })
                        objValue['TRACKING_REPORT_DETAILS'][currentSelectedField?.current?.id || 0]['TRACKING_REPORT_FIELD'][key] = val;
                    }
                } else if (val === "FALSE") {
                    currentSelectedField?.current?.hasOwnProperty(key) && delete currentSelectedField.current[key];
                    gridAPI && gridAPI.forEachNode((node) => {
                        if (node.data?.id === currentSelectedField?.current?.id) {
                            node?.data?.hasOwnProperty(key) && delete node.data[key];
                        }
                    })
                    objValue['TRACKING_REPORT_DETAILS'][currentSelectedField?.current?.id || 0]['TRACKING_REPORT_FIELD'].hasOwnProperty(key)
                        && delete objValue['TRACKING_REPORT_DETAILS'][currentSelectedField?.current?.id || 0]['TRACKING_REPORT_FIELD'][key];
                } else {
                    currentSelectedField.current[key] = val;
                    gridAPI && gridAPI.forEachNode((node) => {
                        if (node.data?.id === currentSelectedField?.current?.id) {
                            node.data[key] = val;
                        }
                    })
                    objValue['TRACKING_REPORT_DETAILS'][currentSelectedField?.current?.id || 0]['TRACKING_REPORT_FIELD'][key] = val;
                }
                setCurrentSelectedFieldState(currentSelectedField.current);
            }

            if(!key && Object.keys(valuesObj).length) {

                Object.keys(valuesObj).forEach((e) => {

                    if (valuesObj[e] === undefined || valuesObj[e] === null || valuesObj[e] === "")
                        currentSelectedField.current?.hasOwnProperty(e) && delete currentSelectedField.current[e];
                    else currentSelectedField.current[e] = valuesObj[e];

                    if (valuesObj[e] === undefined || valuesObj[e] === null || valuesObj[e] === "")
                        objValue['TRACKING_REPORT_DETAILS'][currentSelectedField?.current?.id || 0]['TRACKING_REPORT_FIELD']?.hasOwnProperty(e) &&
                            delete objValue['TRACKING_REPORT_DETAILS'][currentSelectedField?.current?.id || 0]['TRACKING_REPORT_FIELD'][e];
                    else objValue['TRACKING_REPORT_DETAILS'][currentSelectedField?.current?.id || 0]['TRACKING_REPORT_FIELD'][e] = valuesObj[e];
                });

                setCurrentSelectedFieldState(currentSelectedField.current);

                gridAPI && gridAPI.forEachNode((node) => {
                    if (node.data?.id === currentSelectedField?.current?.id) {
                        Object.keys(valuesObj).forEach((e) => {
                            if (valuesObj[e] === undefined || valuesObj[e] === null || valuesObj[e] === "")
                                node.data?.hasOwnProperty(e) && delete node.data[e];
                            else node.data[e] = valuesObj[e];
                        });
                    }
                })
            }

            if(deleteField?.length){
                deleteField.forEach(item => {
                    if (fieldData?.hasOwnProperty(item))
                        delete objValue['TRACKING_REPORT_DETAILS'][currentSelectedField?.current?.id || 0]['TRACKING_REPORT_FIELD'][item];

                    if(currentSelectedField.current?.hasOwnProperty(item))
                        delete currentSelectedField.current[item];

                    gridAPI && gridAPI.forEachNode((node) => {
                        if (node.data?.id === currentSelectedField?.current?.id) {
                            if (node.data?.hasOwnProperty(item))
                                delete node.data[item];
                        }
                    })
                })
            }

            dispatch(
                treeActions.setRightTreeSelectedNode({
                    screen: parentScreen,
                    type: rightTree.currentTab,
                    data: objValue,
                })
            );
        })

        dispatch(
            treeActions.setNewRightTreeTranslatedData({
                screen: parentScreen,
                type: rightTree.currentTab,
                data: updatedData,
            })
        );
    }

    const submitChange = (key, val, valuesObj) => {
        
        const updatedData = eachDeep(cloneDeep(translatedData), (objValue) => {
            if (objValue?.key !== selectedNode.key) {
                return;
            }

            if (!key && Object.keys(valuesObj).length) {
                Object.keys(valuesObj).forEach(k => {
                    objValue[k] = valuesObj[k];
                })
            }

            if (key === "NAME") {
                objValue[key] = val;
                objValue['title'] = `Tracking Report: ${val}`;
            } else if (key) {
                objValue[key] = val;
            }

            dispatch(
                treeActions.setRightTreeSelectedNode({
                    screen: parentScreen,
                    type: rightTree.currentTab,
                    data: objValue,
                })
            );
        })
        dispatch(
            treeActions.setNewRightTreeTranslatedData({
                screen: parentScreen,
                type: rightTree.currentTab,
                data: updatedData,
            })
        );
     }

    const debounceChangeHandler = useCallback(debounce(submitChange, 200), [
        rightTree.currentTab,
        rightTree.tree,
    ]);

    const debounceTrfChangeHandler = useCallback(debounce(submitTrfChange, 200), [
        rightTree.currentTab,
        rightTree.tree,
    ])
    
    function sourceTypeValuesHandler(values) {
        const { PARENT, MAPNAME, RECORD_TYPE, ACTION, INDEX, MAP_REPETITION_INDEX, CUSTOM_DB_FIELD, PLUGIN_NAME, PATTERN, WF_ITEM_ID, WF_ITEM_LOCATION, SOURCE_REPEATING_FIELD } = values;
        const newObj = { PARENT, MAPNAME, RECORD_TYPE, ACTION, INDEX, MAP_REPETITION_INDEX, CUSTOM_DB_FIELD, PLUGIN_NAME, WF_ITEM_ID, WF_ITEM_LOCATION, SOURCE_REPEATING_FIELD }
 
        if (PATTERN || ["TODAY", "TOMORROW", "YESTERDAY"].includes(MAPNAME)) {
            setIsIbPatternDisabled(true);
            debounceTrfChangeHandler(null, null, newObj, ["INBOUND_PATTERN"]);
        }
        else {
            setIsIbPatternDisabled(false);
            debounceTrfChangeHandler(null, null, newObj);
        }

    }

	const formattingOptionsHandler = (prop, newVal, bulk) => {        
		debounceTrfChangeHandler(prop, newVal, bulk);
	};

    function onStatementTypeChange(stmtType, trName) {
        let inType = leftTree?.inboundDependencyTree?.templateHeader?.FILETYPE || "";
        let outType = rightTree?.tree?.templateHeader?.FILETYPE || "";

        if(inType === "EDI" && leftTree?.inboundDependencyTree?.templateHeader?.TXN_SET_TYPE === "997")
            inType = "EDI_997";

        if(outType === "EDI" && rightTree?.tree?.templateHeader?.TXN_SET_TYPE === "997")
            outType = "EDI_997";

        if (!gridAPI)
            return;

        dispatch(
            api.endpoints.trackingReportAutomapping.initiate(
                {
                    data: {
                        account_name: account,
                        user_name: user,
                        statement_type: stmtType,
                        selected_tr_name: trName || trackingReport || "",
                        in_template: inType,
                        out_template: outType,
                        template_name: leftTree?.tree?.body?.selectedNode?.title || "",
                        wfg: leftTree?.tree?.body?.selectedNode?.workflowGroup || "",
                        is_workflow: false
                    }
                }, {forceRefetch: true}
            )
        )
            .then(({ data: { data: trackingReportFields } }) => {

                let newRowData = trackingReportFields && Object.values(trackingReportFields)?.map((item, index) => {

                    let returnObj = {
                        id: index,
                        name: item.TRF_FIELD_NAME,
                        ...item
                    };

                    if (stmtType?.toUpperCase() === "UPDATE")
                        returnObj.isKey = item.IS_KEY === "TRUE" ? "Y" : "N";
                        
                    return returnObj;
                })

                gridAPI.setGridOption("rowData", newRowData);
                gridAPI.setGridOption("columnDefs", stmtType?.toUpperCase() === "UPDATE" ? columns[stmtType?.toUpperCase()] : columns[stmtType?.toUpperCase()]);
                let updateObj = {
                    "TRACKING_REPORT_DETAILS": Object.keys(trackingReportFields).length ?
                        Object.values(trackingReportFields).map((field) => {
                            let returnObj = { ...field };

                            if (stmtType?.toUpperCase() === "UPDATE")
                                returnObj.IS_KEY = field.IS_KEY === "TRUE" ? "Y" : "N";

                            return { TRACKING_REPORT_FIELD: returnObj }
                        }) : [],
                    "TRI_STMT_TYPE": stmtType
                };

                setTimeout(() => {
                    let firstRow = gridAPI.getRowNode(0);
                    currentSelectedField.current = firstRow?.data;            
                    firstRow && firstRow.setSelected(true);
                }, 400);

                if(trName) updateObj.TRI_RPT_NAME = trName;
                if(!selectedNode?.NAME) updateObj.NAME = "UNNAMED";

                debounceChangeHandler(
                    null, null, updateObj
                );
            })
    }

    function checkFieldChange(stmtType, trName) {
        let inType = leftTree?.inboundDependencyTree?.templateHeader?.FILETYPE || "";
        let outType = rightTree?.tree?.templateHeader?.FILETYPE || "";

        if (inType === "EDI" && leftTree?.inboundDependencyTree?.templateHeader?.TXN_SET_TYPE === "997")
            inType = "EDI_997";

        if (outType === "EDI" && rightTree?.tree?.templateHeader?.TXN_SET_TYPE === "997")
            outType = "EDI_997";

        if (!gridAPI)
            return;

        dispatch(
            api.endpoints.trackingReportAutomapping.initiate(
                {
                    data: {
                        account_name: account,
                        user_name: user,
                        statement_type: stmtType,
                        selected_tr_name: trName || trackingReport || "",
                        in_template: inType,
                        out_template: outType,
                        template_name: leftTree?.tree?.body?.selectedNode?.title || "",
                        wfg: leftTree?.tree?.body?.selectedNode?.workflowGroup || "",
                        is_workflow: false
                    }
                }, {forceRefetch: true}
            )
        )
            .then(({ data: { data: trackingReportFields } }) => {

                const keysInSelectedObj = selectedNode?.TRACKING_REPORT_DETAILS.map((item) => item?.TRACKING_REPORT_FIELD?.TRF_FIELD_NAME);
                const keysInApiObj = Object.keys(trackingReportFields);
                
                const removedKeys = keysInSelectedObj.filter(item => !keysInApiObj.includes(item));
                const addedKeys = keysInApiObj.filter(item => !keysInSelectedObj.includes(item));
                const gridData = [];
                const updatedTreeData = cloneDeep(selectedNode?.TRACKING_REPORT_DETAILS) || [];

                selectedNode?.TRACKING_REPORT_DETAILS?.forEach((e, i) => {
                    if(removedKeys.includes(e?.TRACKING_REPORT_FIELD?.TRF_FIELD_NAME)) return;

                    let returnObj = {
                        id: i,
                        name: e?.TRACKING_REPORT_FIELD?.TRF_FIELD_NAME,
                        ...e?.TRACKING_REPORT_FIELD,
                    };

                    if (stmtType?.toUpperCase() === "UPDATE"){
                        const isKeyFromApi = trackingReportFields[e?.TRACKING_REPORT_FIELD?.TRF_FIELD_NAME]?.IS_KEY === "TRUE" ? "Y" : "N";
                        const isKeyFromSelectedNode = e?.TRACKING_REPORT_FIELD?.IS_KEY === "Y" ? "Y" : "N";
                        returnObj.isKey = isKeyFromApi || isKeyFromSelectedNode;
                    }

                    gridData.push(returnObj)
                })

                if (addedKeys.length || removedKeys.length) {
                    let maxId = Math.max(...gridData.map((item) => item.id));

                    Object.values(trackingReportFields)?.forEach((item) => {
                        if (addedKeys.includes(item.TRF_FIELD_NAME)) {
                            const obj = {
                                id: ++maxId,
                                name: item.TRF_FIELD_NAME,
                                ...item
                            };
                            
                            if (stmtType?.toUpperCase() === "UPDATE")
                                obj.isKey = item?.IS_KEY === "TRUE" ? "Y" : "N";

                            gridData.push(obj);
                        }
                    })

                    removedKeys.forEach((item) => {
                        const index = updatedTreeData.findIndex((e) => e?.TRACKING_REPORT_FIELD?.TRF_FIELD_NAME === item);
                        if (index !== -1) {
                            updatedTreeData.splice(index, 1);
                        }
                    })

                    Object.values(trackingReportFields).forEach((field) => {
                        if (addedKeys.includes(field.TRF_FIELD_NAME)) {
                            let returnObj = { ...field };

                            if (stmtType?.toUpperCase() === "UPDATE")
                                returnObj.IS_KEY = field.IS_KEY === "TRUE" ? "Y" : "N";

                            updatedTreeData.push({ TRACKING_REPORT_FIELD: returnObj })
                        }
                    })
                }

                let updateObj = {
                    "TRACKING_REPORT_DETAILS": updatedTreeData,
                    "TRI_STMT_TYPE": stmtType
                };

                if (trName) updateObj.TRI_RPT_NAME = trName;
                if (!selectedNode?.NAME) updateObj.NAME = "UNNAMED";

                gridData.forEach((item, idx) => { item.id = idx; });

                debounceChangeHandler(null, null, updateObj);

                gridAPI.setGridOption("rowData", gridData);
                gridAPI.setGridOption("columnDefs", stmtType?.toUpperCase() === "UPDATE" ? columns[stmtType?.toUpperCase()] : columns[stmtType?.toUpperCase()]);

                setTimeout(() => {
                    let firstRow = gridAPI.getRowNode(0);
                    currentSelectedField.current = firstRow?.data;
                    firstRow && firstRow.setSelected(true);
                }, 400);
            })
    }

    useEffect(() => {
        if (selectedNode) {
            setTrackingReport(selectedNode?.TRI_RPT_NAME || "editracking");
            setReportName(selectedNode?.NAME || "UNNAMED");
            setStatementType(selectedNode?.TRI_STMT_TYPE || "Insert");
            setPerformCheckbox(selectedNode?.ON_STATEMENT_ERROR_FLIP === "TRUE" ? true : false);
            setIgnoreCheckbox(selectedNode?.UNIQUE === "TRUE" ? true : false);
            currentSelectedField.current = selectedNode?.TRACKING_REPORT_DETAILS?.[0]?.TRACKING_REPORT_FIELD || {};
            setCurrentSelectedFieldState(currentSelectedField.current);
            setFieldType(selectedNode?.TRACKING_REPORT_DETAILS?.[0]?.TRACKING_REPORT_FIELD?.FIELDTYPE || "SELECT");
            
            if (!selectedNode?.TRACKING_REPORT_DETAILS?.NAME &&
                !selectedNode?.TRACKING_REPORT_DETAILS?.length)
                onStatementTypeChange(selectedNode?.TRI_STMT_TYPE?.toUpperCase() || "INSERT", selectedNode?.TRI_RPT_NAME);
            else if (gridAPI) {
                checkFieldChange(selectedNode?.TRI_STMT_TYPE?.toUpperCase() || "INSERT", selectedNode?.TRI_RPT_NAME);
            }
        }
        // eslint-disable-next-line
    }, [selectedNode.key, gridAPI, trackingReportUpdated]);

    useEffect(() => {
        setFieldOptions(fieldOptionsDropdownArray.map((e, i) => {
            return (
                <MenuItem key={`fieldType-${i}`} value={e?.value}>
                    {t(e.text)}
                </MenuItem>
            )
        }))

        dispatch(api.endpoints.getTrackingReports.initiate(
            { user: user, account: account },
        ))
        .then((res) => {
            setReportNameDropdown(res?.data?.tracking_reports);
        })
        // eslint-disable-next-line
    }, []);
  
    return (
        <Box sx={{ padding: "15px 15px" }}>
            <Stack spacing={"15px"}>
                <TextField
                    variant="outlined"
                    size="small"
                    label={t("LBL_TRACKING_REPORT_NAME")}
                    type="text"
                    className={"width-100"}
                    name={"NAME"}
                    value={reportName}
                    autoComplete="off"
                    onChange={(e) => {
                        setReportName(e.target.value);
                        debounceChangeHandler('NAME', e.target.value);
                    }}
                />

                <Autocomplete
                    size='small'
                    variant='outlined'
                    className='width-100'
                    options={reportNameDropdown?.map((item) => item?.name) || []}
                    getOptionLabel={(option) => option}
                    value={trackingReport}
                    inputValue={trackingReport}
                    onBlur={(e) => {
                        if (!e?.target?.value) {
                            setTrackingReport(reportNameDropdown[0]?.name);
                            onStatementTypeChange(statementType, reportNameDropdown[0]?.name);
                        }
                    }}
                    onChange={(event, newValue) => {
                        setTrackingReport(newValue || reportNameDropdown[0]?.name);
                        onStatementTypeChange(statementType, newValue || reportNameDropdown[0]?.name);
                    }}
                    renderInput={(params) => (
                        <TextField
                            autoComplete={"off"}
                            {...params}
                            onChange={(event, newValue) => {
                                const value = event.target.value
                                    ? event.target.value
                                    : reportNameDropdown[0];
                                setTrackingReport(event.target.value);
                            }}
                        label={t("LBL_TRACKING_REPORT")}
                        />
                    )}
                />

                <Autocomplete
                    size='small'
                    variant='outlined'
                    className='width-100'
                    options={statementTypeDropdown}
                    getOptionLabel={(option) => option}
                    value={statementType}
                    inputValue={statementType}
                    onBlur={(e) => {
                        if (!e?.target?.value) setStatementType(statementTypeDropdown[0]);
                    }}
                    onChange={(event, newValue) => {
                        const val = newValue || statementTypeDropdown[0] || "Insert";
                        setStatementType(val);
                        if (selectedNode?.TRACKING_REPORT_DETAILS?.length)
                            checkFieldChange(val);
                        else
                            onStatementTypeChange(val);
                    }}
                    renderInput={(params) => (
                        <TextField
                            autoComplete={"off"}
                            {...params}
                            onChange={(event, newValue) => {
                                setStatementType(event.target.value);
                            }}
                        label={t("LBL_STATEMENT_TYPE")}
                        />
                    )}
                />

                {
                    statementType.toLowerCase() === "update" &&
                    <div>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Checkbox
                                checked={performCheckbox}
                                onChange={(e) => {
                                    setPerformCheckbox(e.target.checked);
                                    debounceChangeHandler("ON_STATEMENT_ERROR_FLIP", e.target.checked ? "TRUE" : "FALSE");
                                }}
                            />
                            <Typography>{t("BTN_INSERT_IF_UPDATE_FAILS")}</Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Checkbox
                                checked={ignoreCheckbox}
                                onChange={(e) => {
                                    setIgnoreCheckbox(e.target.checked);
                                    debounceChangeHandler("UNIQUE", e.target.checked ? "TRUE" : "FALSE");
                                }}
                            />
                            <Typography>{t("BTN_IGNORE_UPDATE_IF_ALREADY_ACK")}</Typography>
                        </Box>
                    </div>
                }

                <div>
                    <Typography sx={{ paddingBottom: 1, paddingLeft: 1 }}>
                        {t("LBL_TRACKING_REPORT_FIELDS")}
                    </Typography>
                    <CommonGrid
                        rowData={rowData}
                        containerStyle={{
                            height: 200,
                        }}
                        getGridAPI={(e, gridRef) => {
                            setGridAPI(gridRef.api);
                        }}
                        gridProps={{
                            rowSelection: "single",
                            onSelectionChanged: (e) => {
                                let currRow = e.api.getSelectedRows();
                                currentSelectedField.current = cloneDeep(currRow?.[0]) || {};
                                currentSelectedField.current.RPT_TRUNC_ERR = currRow?.[0]?.RPT_TRUNC_ERR || "TRUE";
                                setCurrentSelectedFieldState(currentSelectedField.current);
                                setFieldType(currentSelectedField.current?.FIELDTYPE);
                                setConstantValue(currentSelectedField.current?.VALUE);
                                setRepeatTimes(currentSelectedField.current?.REPEAT);
                                setIgnoreGlobalSubstitution(currentSelectedField.current?.IGNORE_GLOBAL_SUBSTITUTION || false);
                                if (currentSelectedField.current?.INBOUND_PATTERN)
                                    setIsIbPatternDisabled(false);
                                else
                                    setIsIbPatternDisabled(true);
                            }
                        }}
                    />
                </div>

                <FormControl
                    variant='outlined'
                    className='width-100'
                    size='small'
                >
                    <InputLabel>{t("LBL_FIELD_TYPE")}</InputLabel>
                    <Select
                        variant='outlined'
                        size='small'
                        className={"width-100"}
                        value={
                            fieldOptions.filter((e) => e.props.value === fieldType)
                                ?.length
                                ? fieldType
                                : fieldOptions?.length ? "SELECT" : ''
                        }
                        onChange={(e) => {
                            const value = e.target.value;
                            setFieldType(value);
                            debounceTrfChangeHandler("FIELDTYPE", value);
                        }}
                    >
                        {fieldOptions}
                    </Select>

                    {fieldType === "CONSTANT" && (
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "15px",
                            marginTop: "15px"
                        }}>
                            <ConstantValueControl
                                constantValue={constantValue}
                                setConstantValue={(value) => {
                                    setConstantValue(value);
                                    if (currentSelectedFieldState?.REPEAT && currentSelectedFieldState?.LENGTH) {
                                        //change length based on constant value * repeat times
                                        const newLength = (parseInt(repeatTimes)) * (value?.length || 0);
                                        debounceTrfChangeHandler(
                                            null,
                                            null,
                                            {
                                                VALUE: value,
                                                LENGTH: newLength.toString()
                                            }
                                        )
                                    } else {
                                        debounceTrfChangeHandler("VALUE", value);
                                    }
                                }}
                                constantValueOptions={constantValueDropDownMenu}
                            />

                            <FormControl
                                variant='outlined'
                                className='width-100'
                                size='small'
                            >
                                <TextField
                                    autoComplete={"off"}
                                    size='small'
                                    value={repeatTimes}
                                    label={t("LBL_REPEAT_#_TIMES")}
                                    onChange={(e) => {
                                        const value = (typeof e?.target?.value === "string" && e?.target?.value !== "") ? e?.target?.value : "";
                                        const newValue = value.substring(0, 9).replaceAll(/\D/g, "");
                                        if (newValue !== repeatTimes) {
                                            const newLength = parseInt(newValue) * constantValue.length;
                                            setRepeatTimes(newValue);
                                            debounceTrfChangeHandler(null, null, { "REPEAT": newValue, "LENGTH": newLength.toString() });
                                        }
                                    }}
                                />
                            </FormControl>

                            <div className='flex flex-wrap'>
                                <LabeledCheckbox
                                    checked={ignoreGlobalSubstitution}
                                    handleCheck={(checked) => {
                                        setIgnoreGlobalSubstitution(checked);
                                        debounceTrfChangeHandler("IGNORE_GLOBAL_SUB", checked);
                                    }}
                                    label={t("IGNORE_GLOBAL_SUB")}
                                />
                            </div>
                        </div>
                    )}
                    {
                        fieldType === "BIT_FLAG" && (
                            <div style={{ display: "flex", flexDirection: "column", gap: "15px", marginTop: "15px" }}>
                                <FormControl
                                    variant='outlined'
                                    className='width-100'
                                    size='small'
                                >
                                    <InputLabel>{t("LBL_BIT_POSITION")}</InputLabel>
                                    <Select
                                        variant='outlined'
                                        size='small'
                                        className={"width-100"}
                                        value={bitPosition}
                                        onChange={(e) => {
                                            const { value } = e.target;
                                            setBitPosition(value);
                                            debounceTrfChangeHandler("BIT_POSITION", value);
                                        }}
                                    >
                                        {bitPositionDropdown}
                                    </Select>
                                </FormControl>
                                <FormControl
                                    variant='outlined'
                                    className='width-100'
                                    size='small'
                                >
                                    <InputLabel>{t("LBL_BIT_VALUE")}</InputLabel>
                                    <Select
                                        variant='outlined'
                                        size='small'
                                        className={"width-100"}
                                        value={bitValue}
                                        onChange={(e) => {
                                            const { value } = e.target;
                                            setBitValue(value);
                                            debounceTrfChangeHandler("VALUE", value);
                                        }}
                                    >
                                        {bitValueDropdown}
                                    </Select>
                                </FormControl>
                            </div>
                        )
                    }

                    {
                        (fieldType !== 'CONSTANT' && fieldType !== "BIT_FLAG") && (
                            <Accordion defaultExpanded sx={styles.accordianContainer}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls='accordianFormattingOptions'
                                    id='dataSource'
                                    className='accordian-override'
                                    sx={styles.accordianHeader}
                                >
                                    <SectionHeader text={`${t("LBL_DATA_SOURCE")}`} />
                                </AccordionSummary>
                                <AccordionDetails sx={styles.accordianContent}>
                                    <Stack spacing={"10px"} marginTop={"10px"}>
                                        <SourceType
                                            disabled={!selectedNode?.key}
                                            node={{
                                                PARENT: currentSelectedFieldState?.PARENT,
                                                MAPNAME: currentSelectedFieldState?.MAPNAME,
                                                RECORD_TYPE: currentSelectedFieldState?.RECORD_TYPE,
                                                ACTION: currentSelectedFieldState?.VARIABLE_COLLECTION_ACTION,
                                                INDEX: currentSelectedFieldState?.VARIABLE_COLLECTION_INDEX,
                                                MAP_REPETITION_INDEX: currentSelectedFieldState?.MAP_REPETITION_INDEX,
                                                CUSTOM_DB_FIELD: currentSelectedFieldState?.CUSTOM_DB_FIELD,
                                                PLUGIN_NAME: currentSelectedFieldState?.PLUGIN_NAME,
                                                key: currentSelectedFieldState?.id,
                                            }}
                                            key={currentSelectedFieldState?.id}
                                            valuesHandler={sourceTypeValuesHandler}
                                        />
                                    </Stack>
                                </AccordionDetails>
                            </Accordion>
                        )
                    }

                    {
                        [
                            "DATE",
                            "ALPHA",
                            "INTEGER",
                            "FLOAT",
                            "ZONED_INT",
                            "PACKED_INT",
                            "INTEGER",
                        ].includes(fieldType) && fieldType !== "SELECT" && (
                            <Accordion sx={styles.accordianContainer} defaultExpanded>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls='accordianFormattingOptions'
                                    id='formattingOptions'
                                    className='accordian-override'
                                    sx={styles.accordianHeader}
                                >
                                    <SectionHeader text={t("LBL_FORMATE_OPTIONS")} />
                                </AccordionSummary>
                                <AccordionDetails sx={styles.accordianContent}>
                                    {selectedNode && (
                                        <FormattingOptions
                                            key={currentSelectedFieldState?.TRF_FIELD_NAME}
                                            node={currentSelectedFieldState}
                                            valueshandler={formattingOptionsHandler}
                                            callerComponent={isIbPatternDisabled ? "TRACKING_REPORT_PROPERTIES" : ""}
                                        />
                                    )}
                                </AccordionDetails>
                            </Accordion>
                        )
                    }
                    
                </FormControl>
            </Stack>
        </Box>
    )
}

export default TrackingReportProperties;

const styles = {
	fpContainer: {
		padding: "0 4px 4px 4px",
	},
	accordianContainer: {
		border: "none",
		padding: "0",
		margin: "0",
		boxShadow: "none",
		backgroundColor: "unset",
	},
	accordianHeader: {
		border: "none",
		padding: "0",
		margin: "0",
		backgroundColor: "unset",
	},
	accordianContent: {
		border: "none",
		padding: "0 0px",
		margin: "0",
		backgroundColor: "unset",
	},
};

const columns = {
    "INSERT": [
        {
            field: 'name',
            headerName: 'Field Name',
            sortable: false,
            flex: 1
        }
    ],
    "UPDATE": [
        {
            field: 'name',
            headerName: 'Field Name',
            sortable: false,
            flex: 2.3
        },
        {
            field: 'isKey',
            headerName: 'Is Key',
            sortable: false,
            flex: 0.7
        }
    ]
}